import * as e from "react";
const l = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.765 9.606a.978.978 0 01-1.742-.382.989.989 0 01.37-.999l3.92-3.943a.977.977 0 011.373 0l3.922 3.943a.989.989 0 01-.38 1.752.977.977 0 01-.993-.371L12 6.372 8.765 9.625v-.02zm6.602 4.598a1.021 1.021 0 011.429 1.427l-4.082 4.078a1.021 1.021 0 01-1.428 0L7.204 15.63a1.019 1.019 0 011.429-1.427L12 17.558l3.367-3.364v.01z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
